import React, { useEffect } from 'react';
import {
  fetchApi,
  getHeaderValue,
  useProduct,
  COMMON_CONSTANTS,
  LoginPage,
  getBrandingLogoAndName
} from '@nile/components';
import SuperOpsLoader from '@nile/components/src/Svg/AnimatedSvg/SuperOpsLoader.svg';
import ModalWrapper from '@nile/components/src/Modals/modalWrapper';
import envConfig from '@nile/home/src/Config/env';
import { loggerInfo } from '@nile/home/src/coralogixRUM';
import { LoginPage as IDPLoginPage } from '@superops/superops-login';
import { withRouter } from 'react-router-dom';
import { Button, TextStyle } from '@superops/ui-design-system';
import { FormattedMessage } from 'react-intl';

const stageconfig = {
  development: 'PRESTAGE',
  alpha: 'PRESTAGE',
  production: 'production'
};
function LoginPageIdp() {
  const [loginConfi, setLoginConfi] = React.useState(null);
  const [fetching, setFetching] = React.useState(false);
  const [customerLogin, setCustomerLogin] = React.useState(false);
  const [loginType, setLoginType] = React.useState(null);
  const [companyMeta, setCompanyMeta] = React.useState(null);
  const productType = useProduct();
  const dcRegion = localStorage.getItem('dcRegion');
  const devMode = process.env.NODE_ENV === 'development';
  const userType =
    productType === COMMON_CONSTANTS.MSP ? 'APPLICATION_USER' : 'IDP_USER';

  const pushLogs = (message, errorCode) => {
    loggerInfo('LoginSubscriptionError', {
      domain: window.location.origin,
      errorCode: errorCode,
      errorMessage: message
    });
  };
  const fetchLoginConfiguration = async () => {
    const requestOptions = {
      method: 'GET',
      headers: getHeaderValue(),
      credentials: 'include'
    };
    try {
      setFetching(true);
      const response = await fetchApi(
        `${envConfig.loginRoot}/login/accountloginconfiguration`,
        requestOptions
      );
      const data = await response.json();
      const dta = data;
      setLoginConfi(dta);
      const cmpMeta = await getBrandingLogoAndName();
      setCompanyMeta(cmpMeta);
      setFetching(false);
      if (!response.ok) {
        switch (response.status) {
          case 1027:
            pushLogs(response.status, 'SSO - Email attribute missing');
            break;
          case 1028:
            pushLogs(response.status, 'SSO - Error Validating SAML message');
            break;
          case 563:
            pushLogs(response.status, 'Subscription trial has been expired');
            break;
          case 564:
            pushLogs(response.status, 'Subscription has been paused');
            break;
          case 565:
            pushLogs(response.status, 'Subscription has been cancelled');
            break;
          default:
            break;
        }
      }
    } catch (err) {
      setFetching(false);
    }
  };

  const userTypeClick = (type) => {
    setLoginType(type);
    if (type === 'customer') {
      if (loginConfi && loginConfi.clientUserSSOStatus?.ssoEnabled) {
        window.location.replace(loginConfi.clientUserSSOStatus.ssoRedirectUrl);
      } else {
        setCustomerLogin(true);
      }
    } else if (type === 'technician') {
      if (loginConfi && loginConfi.companyUserSSOStatus?.ssoEnabled) {
        setCustomerLogin(false);
      } else {
        setCustomerLogin(false);
      }
    }
  };

  useEffect(() => {
    fetchLoginConfiguration();
  }, []);

  const footerComponent = (
    <div className="flex jctr">
      <Button plain onClick={() => userTypeClick('technician')}>
        <TextStyle weight="Bold">
          <FormattedMessage
            id="idp.login.as.technician"
            defaultMessage={'Login as Technician'}
          />
        </TextStyle>
      </Button>
    </div>
  );

  if (fetching) {
    return (
      <div className="full-height flex-center Scheduling-SuperOps-loader-style">
        <SuperOpsLoader />
      </div>
    );
  }

  if (customerLogin) {
    return (
      <ModalWrapper
        loginPage
        idpFlow
        footer={footerComponent}
        container={<LoginPage idpFlow />}
      />
    );
  }

  return (
    <IDPLoginPage
      appUserMeta={{
        userType: userType,
        productType: productType,
        deviceType: 'WEB'
      }}
      configMeta={{
        datacenter: dcRegion || 'US',
        isDevelopmentMode: devMode,
        stage: stageconfig[process.env.NODE_ENV]
      }}
      companyMeta={companyMeta}
      onUserTypeClick={userTypeClick}
      loginType={loginType}
    />
  );
}

export default withRouter(LoginPageIdp);
